<form [formGroup]="searchForm" autocomplete="off" style="height: 100%">
  <div class="form-controls-padding" style="height: 100%">
    <div class="list-container">
      <dx-data-grid
        style="
          padding-top: 10px;
          padding-bottom: 10px;
          width: 100%;
          height: calc(100vh - 42vh);
        "
        id="aiChatHistoryGrid"
        class="standard-grid"
        noDataText="No previous chats found."
        [dataSource]="customDataSource"
        [keyExpr]="'id'"
        [showColumnHeaders]="false"
        [showRowLines]="false"
        [showBorders]="false"
        [remoteOperations]="{
          paging: true,
          filtering: true,
          sorting: true,
          grouping: false
        }"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [grouping]="{ autoExpandAll: true }"
        [columnAutoWidth]="true"
        i18n-noDataText="@@noChatsText"
      >
        <dxo-load-panel [enabled]="true"></dxo-load-panel>

        <dxo-grouping [autoExpandAll]="true" [allowCollapsing]="false">
        </dxo-grouping>

        <dxo-scrolling
          mode="virtual"
          rowRenderingMode="virtual"
          [renderAsync]="true"
        ></dxo-scrolling>
        <dxo-paging [pageSize]="100"></dxo-paging>

        <dxi-column
          dataField="timePeriodCategory"
          caption=""
          [groupIndex]="0"
          [showWhenGrouped]="false"
          groupCellTemplate="groupTemplate"
          width="0"
        ></dxi-column>

        <div *dxTemplate="let data of 'groupTemplate'">
          <span>{{ data.value }}</span>
        </div>

        <dxi-column
          cssClass="name-data-cell"
          dataField="name"
          caption=""
        ></dxi-column>

        <dxi-column
          dataField="updatedAt"
          caption=""
          hidden="true"
          sortOrder="desc"
          sortIndex="0"
        ></dxi-column>

        <dxi-column
          dataField="createdAt"
          caption=""
          hidden="true"
          sortOrder="desc"
          sortIndex="1"
        ></dxi-column>

        <dxi-column
          width="55"
          alignment="center"
          dataField="openChat"
          caption=""
          cellTemplate="openTemplate"
          [allowSorting]="false"
        ></dxi-column>

        <dxi-column
          width="55"
          alignment="center"
          dataField="deleteChat"
          caption=""
          cellTemplate="deleteTemplate"
          [allowSorting]="false"
        ></dxi-column>

        <div *dxTemplate="let cell of 'openTemplate'">
          <button
            (click)="openChat(cell)"
            class="atlas-icon-button atlas-primary-icon-button"
            color="primary"
            matTooltip="Open this chat"
            i18n-matTooltip="@@openThisChat"
            mat-flat-button
            [disabled]="isChatSelected(cell.data.conversationId)"
          >
            <mat-icon>swap_horiz</mat-icon>
          </button>
        </div>

        <div *dxTemplate="let cell of 'deleteTemplate'">
          <button
            (click)="deleteChat(cell)"
            class="atlas-icon-button atlas-secondary-icon-button"
            color="primary"
            matTooltip="Delete chat"
            i18n-matTooltip="@@deleteChat"
            mat-flat-button
            [disabled]="isChatSelected(cell.data.conversationId)"
          >
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </dx-data-grid>
    </div>
  </div>
</form>
